<template>
	<div class="st-main-content">
		<div class="query-setting-box">
			<div class="query-setting-box-left">
				<div class="order-query-form-box" style="width: 180px;">
					<label for="start-date"><span class="">注册起始时间<i class="icon_select"></i></span> </label>
					<span class="order-query-form-input">
						<el-date-picker
							v-model="orderForm.regBeginTime"
							type="datetime"
							placeholder="选择日期时间"
							class="setTimePicker"
							value-format="yyyy-MM-dd HH:mm:ss"
							>
					 	 </el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box" style="width: 180px;">
					<label for="start-date">至：</label>
					<span class="order-query-form-input">
						<el-date-picker
							v-model="orderForm.regEndTime"
							type="datetime"
							placeholder="选择日期时间"
							class="setTimePicker"
							value-format="yyyy-MM-dd HH:mm:ss"
							>
					 	 </el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box" style="width: 180px;">
					<label for="start-date"><span class="">审核时间<i class="icon_select"></i></span> </label>
					<span class="order-query-form-input">
						<el-date-picker
							v-model="orderForm.auditBeginTime"
							type="datetime"
							placeholder="选择日期时间"
							class="setTimePicker"
							value-format="yyyy-MM-dd HH:mm:ss"
							>
					 	 </el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box" style="width: 180px;">
					<label for="start-date">至：</label>
					<span class="order-query-form-input">
						<el-date-picker
							v-model="orderForm.auditEndTime"
							type="datetime"
							placeholder="选择日期时间"
							class="setTimePicker"
							value-format="yyyy-MM-dd HH:mm:ss"
							>
					 	 </el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">业务员手机号：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.salemanPhone"  name="start-date"></span>
				</div>
				
		<!-- 	<div class="order-query-form-box">
				<label for="start-date">业务员姓名：</label>
				<span class="order-query-form-input"><input type="text" v-model="orderForm.salemanName"  name="start-date"></span>
			</div> -->
				<div class="order-query-form-box">
					<label for="start-date">身份证号码：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.idCard"  name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">名字：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.name" name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">注册手机号：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.phone" name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">是否审核：</label>
					<span class="order-query-form-input">
						<el-select v-model="orderForm.isAudit" placeholder="请选择" class="stSetSelect">
							<el-option
							v-for="item in isAuditList"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">用户状态：</label>
					<span class="order-query-form-input">
						<el-select v-model="orderForm.userStatus" placeholder="请选择" class="stSetSelect">
							<el-option
							v-for="item in userStatusList"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</span>
				</div>
			</div>	
			<div class="order-query-form-box-right">
				<span class="order-query-form-submit stPointer"   @click="searchList(true)">查询</span>
			</div>
		</div>
		<!-- :selectType='true' -->
		<div class="data-table-box">
			<common-table ref="CommonTableRef" 
				:tableColumns="tableColumns" 
				:data="dataList" 
				:showPage="togglePage"
				:loading="loading" 
				:pageConfig="pageConfig"
				:bottomHandleArr="bottomHandleArr" 
				
				@selectionChange="selectionChange" 
				@currentChange="currentChange"
				@sizeChange="sizeChange">
			</common-table>
		</div>
		<div class="previewImg" v-if="toggleImg">
			<img @click="toggleImg=false" class="closeImg" src="../../assets/images/close.png" alt="">
			<div class="previewImgWarp">
				<div class="mypreviewImg">
					<img :src="previewPath" >
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	const pageShowArr = [
		{label: '选择',width: '64',prop: '',type:"selection"},
		{prop: 'regTimeFormatted',width: '198',label: '注册时间'},
		{prop: 'auditStateDesc',width: '198',label: '是否审核'},
		{prop: 'userStatusDesc',width: '198',label: '状态'},
		{prop: 'phone',width: '198',label: '货主电话'},
		{prop: 'reviewer',width: '198',label: '审核人'},
		{prop: 'auditTimeFormatted',width: '198',label: '审核时间'},
		{prop: 'carNo',width: '250',label: '车牌号'},
		{label: '车头照',width: '250',prop: 'carHeadUrl',viewImg:true},
		{label: '驾驶证',width: '250',prop: 'driverLicenseUrl',viewImg:true},			
	]
	const unbindList = []
export default {
	name: 'ShipperMaterial',
	props: [],
	components: {},
	data(){
		return{
			tableColumns:[
				{type:"selection",fixed:'left'},
				{key: 'regTimeFormatted',width: '198',title: '注册时间'},
				{key: 'auditStateDesc',width: '198',title: '是否审核'},
				{key: 'userStatusDesc',width: '198',title: '状态'},
				{key: 'phone',title: '货主电话'},
				{key: 'salemanPhone',title: '业务员手机号'},
				{key: 'salemanName',title: '业务员名称'},
				{key: 'numAddress',title: '号码归属地'},
				{key: 'reviewer',width: '80',title: '审核人'},
				{key: 'auditTimeFormatted',width: '198',title: '审核时间'},
				{key: 'carNo',width: '250',title: '车牌号'},
				{
					title: '车头照',
					width: '100',
					imgProps:'carHeadUrl',
					viewImg:true,
					handler: (row) => this.argImg(row)},
				{title: '驾驶证',width: '100',
					imgProps:'driverLicenseUrl',
					viewImg:true,
					handler: (row) => this.argImg(row)
				},			
			],

			loading: false,
			pageConfig: {
				total: 0,
				pageSize: 50,
				currentPage: 1,
			},
			bottomHandleArr: [
				{
					label: '解冻',
					handler: () => this.freezeUser(1)
				},{
					label: '冻结',
					type: 'success',
					handler: () => this.freezeUser(2)
				},{
					label: '审核',
					type: 'success',
					handler: () => this.setAudit()
				},{
					label: '导出',
					type: 'success',
					handler: () => this.exportData()
				},{
					label: '解绑业务员',
					handler: () => this.unbind()
				},
			],

			previewPath:null,
			dataList:[], //订单列表
			orderForm:{
				carNo: null, //	车牌号	string	
				idCard: null, //	身份证号码	string	
				isAudit: null, //	是否审核：0=未通过、1=已通过、null=全部	number	
				name: null, //	名字	string	
				phone: null, //	注册手机号	string	
				regBeginTime: null, //	注册起始时间	string	格式：yyyy-MM-dd HH:mm:ss
				regEndTime: null, //	注册结束时间	string	格式：yyyy-MM-dd HH:mm:ss
				userStatus: '', //	用户状态 1=正常 2=冻结 3=注销	number	
				userType: 1, //	用户类型 1=货主 2=司机	string	
			},
			toggleImg:false,
			togglePage:false, //是否显示分页
			selDriverId:null, //选中的司机
			selectedList:[],// 选中的列表
			driverList:[],// 司机列表
			isAuditList:[{
					value: 0,
					label: '未通过'
				}, {
					value: 1,
					label: '已通过'
				}, {
					value: null,
					label: '全部'
			}],
			userStatusList:[
				{
					value: '',
					label: '全部'
				},
				{
					value: 1,
					label: '正常'
				}, {
					value: 2,
					label: '冻结'
				}, {
					value: 3,
					label: '注销'
			}],
			pageShowArr: pageShowArr
		}
	},
	created() {},
	methods: {
		sizeChange(size) {
			this.pageConfig.currentPage = 1
			this.pageConfig.pageSize = size
			this.searchList()
		},

		currentChange(currentPage) {
			this.pageConfig.currentPage = currentPage
			this.searchList()
		},
		freezeUser(flag) {
			if(this.selectedList.length != 1){
				this.$toast.stMessage('请选择一个用户',true)
				return;
			}
			// 冻结
			this.$server.material.freezeUser({
				id: this.selectedList[0].id,
				userStatus: flag
			},(res)=>{
				this.$toast.stMessage(flag==1?'解冻成功':'冻结成功',true)
				this.searchList();
			})
			
		},
		argImg(src){
			this.previewPath=src;
			this.toggleImg=true;
		},
		searchList(flag){
			let pages={};
			pages.size = this.pageConfig.pageSize;
			pages.current = this.pageConfig.currentPage;
			if(flag) pages.current = 1;
			let orderForm=this.orderForm;
			Object.assign(orderForm,pages)
			this.getData(orderForm)
		},
		
		getData(data){
			this.$server.material.stPage(data,(res)=>{
				if(res.code==0){
					this.dataList=res.data.records;
					this.pageConfig.total = res.data.total;
					this.pageConfig.currentPage = res.data.current;
					if(res.data.total>0){
						this.togglePage=true;
					}
				}
			})
		},
		// 审核
		setAudit(){
			let that=this;
			if(this.selectedList.length<1){
				that.$toast.stMessage('请选择货主',true)
				return;
			}
			let listId=[];
			if(this.selectedList.length>0){
				this.selectedList.forEach(item => {
					listId.push(item.id)
				});
			}
			this.$server.material.auditCheck(listId,(res)=>{
				if(res.code==0){
					that.$toast.stMessage('审核通过',true)
					that.searchList();
				}else{
					that.$toast.stMessage(res.message,false)
				}
			})
		},
		//解绑业务员
		unbind() {
			
			console.log(this.selectedList)
			if(this.selectedList.length <1){
				this.$toast.stMessage('请至少选择一个用户',true)
				return;
			}else{
				for(var i = 0;i <this.selectedList.length;i++){
					unbindList.push(this.selectedList[i].id)
				}
				console.log(unbindList)
				// 解绑
				this.$server.material.unbind({
					id: unbindList,
				},(res)=>{
					if (res.code == 0) {
					this.$toast.stMessage('解绑成功', true)
					this.searchList()
					unbindList.length =0
					}
				})
			}
			
			
		},
		selectionChange(row){
			this.selectedList=row;
		},
		exportData(){
			let that = this;
			if (this.dataList.length < 1) {
				that.$toast.stMessage('暂无数据', true)
				return;
			}
			let pages = {};
			pages.size = this.pageConfig.pageSize;
			pages.current = this.pageConfig.currentPage;
			const sendData = {
				...this.orderForm,
				exportColumnFiledNames: this.tableColumns.map((item) =>{
					return item.key || item.imgProps
				}).filter(item => {
					return item && item.trim()
				})
			}
			sendData.createTimeBegin = sendData.createTimeBegin ? new Date(sendData.createTimeBegin).getTime() : ''
			sendData.createTimeEnd = sendData.createTimeEnd ? new Date(sendData.createTimeEnd).getTime() : ''
			Object.assign(sendData, pages)
			this.$server.common.exportTable('/appuser/driverInformationExport',sendData, (res) => {
				console.log('导出成功')
			})
		},
		cellClass(row){ 
			if (row.columnIndex === 0) {           
				return 'disabledCheck'     
			} 
		},
	},
	mounted() {
		
	}
}

</script>
<style scoped>
.shipper-material {
  width: 100%;
  height: auto;
}
.data-table-box {
    height: auto;
    background: #FFF;
    padding: 8px;
    box-sizing: border-box;
}	
.data-table{
	margin-bottom: 8px;
}
.query-setting-box-left{
    flex-grow: 0;
}
.previewImg{
	position: fixed;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	background-color: rgba(0, 0, 0, .5);
	z-index: 99;
}
.previewImgWarp{
	position: absolute;
	left: 50%;
	top: 50%;
	margin-left: -300px;
	margin-top: -300px;
	width: 600px;
	height: 600px;
	display: flex;
	justify-content: center;
	align-items: center;
}
.mypreviewImg{
	display: inline-block;
	border: 5px solid #fff;
	border-radius: 3px;
	overflow: hidden;
}
.mypreviewImg img{
	max-width: 600px;
}
.closeImg{
	position: absolute;
	top: 20px;
	right: 20px;
	cursor: pointer;
}
.stMbgc.success {
	background-color: seagreen;
}
</style>
